import React from 'react';
import { FadeIn, Section } from './ui';
export function ProductSection() {
  const modules = [{
    num: '01',
    title: 'El Despertar Cognitivo',
    desc: '6 scripts de apertura listos para usar según el tipo de aula que tengas. Capturás la atención en los primeros 10 minutos o no la capturás nunca.',
    tag: 'TOMO 1'
  }, {
    num: '02',
    title: 'Ingeniería de la Guía',
    desc: 'Plantillas de guías que se explican solas. Tus alumnos trabajan solos mientras vos observás. Terminan las 30 preguntas repetidas por clase.',
    tag: 'TOMO 2'
  }, {
    num: '03',
    title: 'El Pizarrón Magnético',
    desc: 'El sistema de 4 zonas y código de color que convierte tu pizarrón en una herramienta de comprensión. Lo que escribís, los alumnos lo entienden.',
    tag: 'TOMO 3'
  }, {
    num: '04',
    title: 'Evaluación Blindada',
    desc: 'Exámenes con rúbricas técnicas irrefutables. Ningún padre puede cuestionar la nota. Ninguna IA puede resolverlos sin razonamiento propio.',
    tag: 'TOMO 4'
  }, {
    num: '05',
    title: 'Gestión de Consultas',
    desc: "El banco de 50 respuestas listas para las preguntas más difíciles del aula. Incluyendo '¿para qué sirve esto?' con ejemplos de cripto, fútbol e IA.",
    tag: 'TOMO 5'
  }, {
    num: '06',
    title: 'El Cierre de Autoridad',
    desc: 'El protocolo de 10 minutos que duplica la retención de contenido sin agregar tiempo de clase. Lo último que recordás es lo que más recordás.',
    tag: 'TOMO 6'
  }];
  return <Section variant="light" className="!max-w-none" data-id="element-185">
      <div className="max-w-[800px] mx-auto" data-id="element-186">
        <FadeIn data-id="element-187">
          <h2 className="text-[28px] md:text-4xl font-black text-white mb-6 text-center" data-id="element-188">
            ¿Qué es exactamente Matemática 360?
          </h2>
          <p className="text-gray-300 text-base md:text-lg mb-12 leading-relaxed text-center" data-id="element-189">
            Es un sistema de 6 módulos en formato PDF que cubre los 6 momentos
            críticos de cada clase: cómo empezarla, cómo diseñar las
            actividades, cómo usar el pizarrón, cómo evaluar, cómo gestionar las
            preguntas y cómo cerrar para que los alumnos recuerden lo aprendido.
            <br data-id="element-190" />
            <br data-id="element-191" />
            Cada módulo tiene: la teoría en 2 páginas, los scripts listos para
            usar, las plantillas para copiar y los checklists para verificar
            antes de entrar al aula.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-192">
          {modules.map((mod, i) => <FadeIn key={i} delay={i * 0.07} data-id="element-193">
              <div className="bg-dark border border-brand-orange/30 p-5 md:p-6 rounded-2xl h-full flex flex-col hover:border-brand-orange hover:shadow-[0_8px_30px_rgb(255,107,0,0.12)] transition-all duration-300 relative overflow-hidden group" data-id="element-194">
                <div className="absolute top-0 right-0 bg-brand-orange text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-195">
                  {mod.tag}
                </div>
                <div className="text-3xl md:text-4xl font-black text-gray-800 mb-1 group-hover:text-brand-orange/20 transition-colors" data-id="element-196">
                  {mod.num}
                </div>
                <h3 className="text-lg md:text-xl font-bold text-white mb-2" data-id="element-197">
                  {mod.title}
                </h3>
                <p className="text-sm text-gray-400 leading-relaxed flex-grow" data-id="element-198">
                  {mod.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </Section>;
}